export default "__VITE_ASSET__zo31lZXy__"